import styled from 'styled-components';

const StyledBottomContainer = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 120px;
`;

const StyledControlsContainer = styled.div`
	display: flex;
	position: absolute;
	left: 60px;
	right: 60px;
	bottom: 60px;
	justify-content: space-between;
`;

export { StyledBottomContainer, StyledControlsContainer };
